import React from 'react';
import MesaList from "./MesaList";

function MesasPage() {
  return (
    <div className="container mt-4">
      <MesaList />
    </div>
  );
}

export default MesasPage;
